import { mapToDefaults } from './utils';

export const docsToDefaults = (docs) => {
    return mapToDefaults(docs.props);
}